import classNames from 'classnames';
import React from 'react';
import ReactSelect from 'react-select';
import InputLabel from '../InputLabel';
import './styles.css';

const Select = ({
  label,
  labelClassName,
  help,
  showHelpTooltip = true,
  errors,
  ...props
}) => {
  return (
    <div className={'select'}>
      <InputLabel
        className={labelClassName}
        label={label}
        help={help}
        showHelpTooltip={showHelpTooltip}
      >
        <ReactSelect
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
          classNames={{
            control: (state) => {
              return classNames(
                'select__control',
                {
                  'select__control--focused': state.isFocused,
                }
              );
            },
            option: (state) => {
              return classNames(
                'select__option',
                {
                  'select__option--selected': state.isSelected,
                  'select__option--focused': state.isFocused,
                }
              );
            },
            loadingIndicator: () => 'select__loading',
            input: () => 'select__input',
            singleValue: () => 'select__single-value',
          }}
          {...props}
        />
        {!!errors && (
          <div className={'text-input__errors'}>
            {Array.isArray(errors) ? (
              errors.map((error, i) => (
                <div className={'text-input__error'} key={i}>{error}</div>
              ))
            ) : (
              <div className={'text-input__error'}>{errors}</div>
            )}
          </div>
        )}
      </InputLabel>
    </div>
  );
};

export default Select;
